import React from 'react'
import { ArrayInput, SimpleFormIterator } from 'react-admin'
import { Drink } from 'services/api/entities/catalog/drink/types/internal/drink-models'
import { WithGetSource } from 'types/common'
import LocalizedSelectInput from 'ui-shared/LocalizedFields/LocalizedSelectInput'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import { WithSelectedProduct } from '../types'

type DrinkFieldsProps = Partial<WithSelectedProduct<Drink> & WithGetSource>

const DrinkPresetAdditionalFields: React.FC<DrinkFieldsProps> = ({
  getSource,
  selectedProduct,
}) => (
  <ArrayInput label="form.fields.variants" source={getSource!('variants')}>
    <SimpleFormIterator>
      <KNumberInput
        label="form.fields.drinkPerPerson"
        source="drinksPerPerson"
      />
      <LocalizedSelectInput
        label="form.fields.variants"
        source="id"
        choices={selectedProduct?.variants}
      />
    </SimpleFormIterator>
  </ArrayInput>
)

export default DrinkPresetAdditionalFields
